module.exports = __webpack_public_path__ + "img/index-sol2.64e4c799.png";